<template>
    <Head :title="chapter?.title || 'Chapter'" />
    <div class="px-4 md:px-8">
        <ChapterComponent />
    </div>
</template>
<script setup>
import { Head } from '@inertiajs/vue3';
import ChapterComponent from '@/components/courses/chapter.vue';
import { useCoursesStore } from '@/store/courses';
import { storeToRefs } from 'pinia';

const store = useCoursesStore();
const { chapter } = storeToRefs(store);
</script>
